var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-navigation',[(_vm.me)?_c('agency-dashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }